import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControlLabel,
    Checkbox
} from '@mui/material';
import { withStyles } from 'tss-react/mui';
import DialogCloseButton from '../../buttons/DialogCloseButton';

const styles = theme => ({
    checkLabel: {
        fontSize: 15,
        opacity: 0.6
    },
    controlLabel: {
        marginLeft: 0
    },
    alert: {
        color: theme.palette.error.main
    },
    dialogTitle: {
        [theme.breakpoints.down('xl')]: {
            display: 'flex',
            justifyContent: "space-between"
        }
    }
});

class ConfirmationDialog extends React.Component {
    state = {
        checked: true
    }

    render() {
        const { classes, title, open, showCheck, okText, hideCancel, alertColor, hideClose, cancelText } = this.props;
        const { checked } = this.state;

        return (
            <Dialog
                open={open}
                onClose={this.handleClose}
                maxWidth='xs'
                fullWidth={true}
                aria-labelledby='confirmation-dialog-title'
            >
                <DialogTitle id='confirmation-dialog-title'>
                    <div className={classes.dialogTitle}>
                        {title}
                        {!hideClose &&
                            <DialogCloseButton
                                onClick={this.handleClose}
                            />
                        }
                    </div>
                </DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    {this.props.children}
                </DialogContent>
                <DialogActions>
                    {showCheck ? 
                        <FormControlLabel
                            label='always ask'
                            labelPlacement='end'
                            classes={{
                                label: classes.checkLabel
                            }}
                            className={classes.controlLabel}
                            control={
                                <Checkbox 
                                    color='default'
                                    checked={checked}
                                    onChange={this.handleCheckChange}
                                />
                            }
                        /> 
                        : null
                    }
                    <div style={{flex: '1 0 0'}} />
                    {!hideCancel ?
                        <Button
                            onClick={() => this.handleCancel()}
                        >
                            {cancelText || 'Cancel'}
                        </Button>
                    : null}
                    <Button
                        onClick={() => this.handleConfirm()}
                        className={alertColor ? classes.alert : null}
                    >
                    {okText || 'OK'}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    componentDidUpdate() {
        const { storageKey, open } = this.props;
        
        if (window.localStorage.getItem(storageKey) && open) {
            this.handleConfirm();
        }
    }

    handleConfirm = () => {
        const { confirmation } = this.props;

        this.handleClose();
        if (typeof confirmation === 'function') confirmation();
    }

    handleCancel = () => {
        const { cancelAction } = this.props;

        this.handleClose();
        if (typeof cancelAction === 'function') cancelAction();
    }

    handleClose = () => {
        const { onClose, storageKey } = this.props;
        const { checked } = this.state;

        if (!checked) {
            window.localStorage.setItem(storageKey, true);
        }

        onClose();
    };

    handleCheckChange = (event) => {
        this.setState({checked: event.target.checked});
    }


}

export default withStyles(ConfirmationDialog, styles);